class FreeQuote extends Utilities {

  constructor() {

    super()

    let modal = new Modal()
        
    let settings = {
      template : '_components/modals/free-quote.twig',
      type     : 'form'
    }

    fetcher.get('/fetch-template', settings, {
      success : (response) => {
        modal.open(response.html, (modal) => {
          modal.classList.add('free-quote');
          let form = modal.querySelector('form');
          console.log(form)

        })
      },
      error : (response) => {
        console.log('ERROR', response);

      }
    })

    document.addEventListener('freeform-ajax-success', function(event) {
      setTimeout(() => {
        modal.close();
      }, 3000) // 5 seconds
    })


  }

}